"use client";
import styles from "@/styles/layout/UserWelcomeBar.module.css";

const UserWelcomeBar: React.FC = () => {

  return (
    <div className={styles.containerLogoHeaderGovco}>
      <div className={styles.leftSection}>
      </div>
      <div className={styles.rightSection}>
        <p>
          <span>
            Formulario público de soporte <br />
          </span>
          <span className={styles.role}>
            Corporación Talentum
          </span>
        </p>
      </div>
    </div>
  );
};

export default UserWelcomeBar;
